import React from "react";
import { inject, observer } from "mobx-react";
import gameActionOptions from "../constants/gameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class WinterGameActionDropDownContainer extends React.Component {
  render() {
    const { WinterGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={gameActionOptions}
        transitionToCreateIncident={
          WinterGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={WinterGameActionStore.clearClippyCache}
        clearStatsApiCache={WinterGameActionStore.clearStatsApiCache}
        resendGame={WinterGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(observer(WinterGameActionDropDownContainer));
